var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "class-1",
    cx: 12,
    cy: 12,
    rx: 4.4,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "class-1",
    cx: 12,
    cy: 12,
    rx: 1.8,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "class-1",
    d: "M23.1,12C20.9,7.5,16.8,4.5,12,4.5C7.3,4.5,3.2,7.5,1,12c2.2,4.5,6.3,7.5,11.1,7.5 C16.8,19.5,20.9,16.5,23.1,12z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/show.887a900c.svg";
export { ForwardRef as ReactComponent };